import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './PrintStyles.css'; // <- create this for @page styling

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = () => {
  const navigate = useNavigate();
  const { filename: encodedFilename } = useParams();

  const [filename, setFilename] = useState('');
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState('');

  useEffect(() => {
    try {
      if (encodedFilename) {
        setFilename(atob(encodedFilename));
      }
    } catch (err) {
      console.error('Invalid base64 filename:', err);
      setError('Invalid file name.');
    }
  }, [encodedFilename]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setError('');
  };

  const onDocumentLoadError = (err) => {
    console.error('Error loading PDF:', err);
    setError('Error loading PDF. Please try again.');
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `http://localhost:3001/datas/${encodeURIComponent(filename)}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-black text-white print:bg-white print:text-black flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-6xl">
        <div className="flex justify-between mb-4 print:hidden">
          <div className="space-x-2">
            <button onClick={handlePrint} className="px-4 py-2 bg-yellow-500 text-black rounded hover:bg-yellow-600">Print</button>
            <button onClick={handleDownload} className="px-4 py-2 bg-yellow-500 text-black rounded hover:bg-yellow-600">Download</button>
            <button onClick={() => navigate(-1)} className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600">Close</button>
          </div>
        </div>

        {error ? (
          <div className="text-red-500">{error}</div>
        ) : (
          <div className="flex flex-col items-center">
            {filename && (
              <Document
                key={filename}
                file={{
                  url: `http://localhost:3001/pdfs/datas/${encodeURIComponent(filename)}`,
                  httpHeaders: {
                    'Content-Type': 'application/pdf'
                  }
                }}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
              >
                <Page
                  pageNumber={pageNumber}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            )}

            {numPages && (
              <div className="flex justify-center items-center mt-4 space-x-4 print:hidden">
                <button
                  onClick={() => setPageNumber(Math.max(1, pageNumber - 1))}
                  disabled={pageNumber <= 1}
                  className="px-4 py-2 bg-gray-600 text-white rounded disabled:opacity-50"
                >
                  Previous
                </button>
                <span className="text-white">Page {pageNumber} of {numPages}</span>
                <button
                  onClick={() => setPageNumber(Math.min(numPages, pageNumber + 1))}
                  disabled={pageNumber >= numPages}
                  className="px-4 py-2 bg-gray-600 text-white rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfViewer;
